import React, {useState} from 'react'
import {Icon} from '@thryvlabs/maverick'

function ToggleSection({
  title = 'Section',
  isOpen = false,
  children,
  description,
}) {
  const [isToggled, setIsToggled] = useState(isOpen)

  return (
    <section style={{margin: '30px 10px'}}>
      <h2
        onClick={() => {
          setIsToggled(!isToggled)
        }}
        className="cursor-pointer"
        style={{
          userSelect: 'none',
          display: 'flex',
          alignItems: 'center',
          gap: '12px',
          fontFamily: "'Inter', 'Helvetica Neue', Arial, sans-serif",
          fontSize: '18px',
          fontWeight: 600,
          color: '#111827',
          margin: '0 0 4px',
        }}
      >
        <Icon
          aria-hidden={isToggled}
          style={{
            cursor: 'pointer',
            width: '15px',
          }}
          type="solid"
          color="#a9a9a9"
          variant={!isToggled ? 'caretDown' : 'caretUp'}
          onClick={() => setIsToggled(prev => !prev)}
        />
        {title}
      </h2>
      {description && (
        <p
          style={{
            fontFamily: "'Inter', 'Helvetica Neue', Arial, sans-serif",
            fontSize: '13px',
            fontWeight: 400,
            color: '#6b7280',
            margin: '4px 0 0',
          }}
        >
          {description}
        </p>
      )}
      <div
        style={{
          display: isToggled ? 'block' : 'none',
        }}
      >
        {children}
      </div>
    </section>
  )
}

export {ToggleSection}
